import React from "react";
import { Edit2, Check, Trash2, X } from "lucide-react";
import IconButton from "../../../ui/Button/IconButton.jsx";

/**
 * ActionButtons - Shared action buttons component for cards
 * 
 * Provides consistent Edit and Delete buttons for EventCard and SpaceCard.
 * Uses lucide-react icons for consistency.
 * 
 * @param {Object} props
 * @param {Function} props.onEdit - Callback when edit button is clicked
 * @param {Function} props.onDelete - Callback when delete button is clicked
 * @param {boolean} props.isEditing - Whether the card is in editing mode
 * @param {boolean} props.showDelete - Whether to show delete button (default: true)
 * @param {string} props.className - Additional CSS classes
 */
const ActionButtons = ({
    onEdit,
    onDelete,
    onCancel,
    isEditing = false,
    showDelete = true,
    className = "",
}) => {
    return (
        <div className={`flex justify-between items-end mt-3 ${className}`}>
            <div className="flex gap-1"></div>
            <div className="flex gap-1">
                <IconButton
                    icon={isEditing ? <Check className="h-3 w-3" /> : <Edit2 className="h-3 w-3" />}
                    variant={isEditing ? "actionButtonActive" : "actionButton"}
                    size="icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        onEdit(e);
                    }}
                />
                {isEditing ? (
                    <IconButton
                        icon={<X className="h-3 w-3" />}
                        variant="actionButton"
                        size="icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            onCancel && onCancel(e);
                        }}
                        className="text-red-500 "
                    />
                ) : (
                    showDelete && (
                        <IconButton
                            icon={<Trash2 className="h-3 w-3" />}
                            variant="actionButtonDelete"
                            size="icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(e);
                            }}
                        />
                    )
                )}
            </div>
        </div>
    );
};

export default ActionButtons;
